import React from "react";
import NavBar from "../components/NavBar";

const EligibilityCalculator = () => {
    return(
        <div>
            <NavBar/>
            Eligibility Calculator
        </div>
    )
}

export default EligibilityCalculator;